/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// export * from "./master-zones-list/master-zones-list.component";
export * from './master-zone-list/master-zone-list.component';
export * from './master-zone-details/master-zone-details.component';
